// extracted by mini-css-extract-plugin
export var subtitle = "_bt-2";
export var title = "_bt-0";
export var titleNoWrap = "_bt-1";